import { ErrorHandler, Injectable } from '@angular/core'

// export interface AsiakaskohtainenCache<T> {
//   cid: number | string,
//   data: T
// }

@Injectable()
export class LocalStorageService {
  constructor(private errorHandler: ErrorHandler) {}

  setToLocalStorage<T>(cacheKey: string, item: T) {
    try {
      if (window && window.localStorage) {
        window.localStorage.setItem(cacheKey, JSON.stringify(item))
      }
    } catch (err) {
      console.log('Virhe tallennettaessa local storage tietoa avaimella ', cacheKey)
      this.errorHandler.handleError(err)
    }
  }

  getFromLocalStorage<T>(cacheKey: string): T | null {
    try {
      if (window && window.localStorage) {
        const cacheStr = window.localStorage.getItem(cacheKey)
        if (cacheStr) {
          return JSON.parse(cacheStr) as T
        }
      }
    } catch (err) {
      console.log('Virhe haettaessa local storage tietoa avaimella ', cacheKey)
      this.errorHandler.handleError(err)
    }
    return null
  }

  setToSessionStorage<T>(cacheKey: string, item: T) {
    try {
      if (window && window.sessionStorage) {
        window.sessionStorage.setItem(cacheKey, JSON.stringify(item))
      }
    } catch (err) {
      console.log('Virhe tallennettaessa session storage tietoa avaimella ', cacheKey)
      this.errorHandler.handleError(err)
    }
  }

  async setToSessionStorageUntilVerified<T>(cacheKey: string, item: T, retriesAllowed: number = 3, retrySleepMs: number = 100) {
    let retries = 0
    while (retries < retriesAllowed) {
      try {
        // Write to session storage
        this.setToSessionStorage(cacheKey, item)
        // Try to read
        const value = await this.getFromSessionStorageWithRetries(cacheKey, 10, 50) // 50ms * 10
        // Check if value could be read and it equals with the expected item
        if (value && JSON.stringify(item) === JSON.stringify(value)) {
          return true
        }
      } catch (err) {
        this.errorHandler.handleError(err)
        // Continue the iterations
      }

      retries++
      console.log(`setToSessionStorageUntilVerified, retry attempt number ${retries}`)

      // Sleep 100 ms before starting next iteration
      await this.sleep(retrySleepMs)
    }

    // Throw if retries fail
    throw new Error(`Virhe tallennettaessa session storage tietoa avaimella ${cacheKey}, uudelleenyritykset ei onnistuneet!`)
  }

  deleteFromSessionStorage(cacheKey: string) {
    try {
      if (window && window.sessionStorage) {
        window.sessionStorage.removeItem(cacheKey)
      }
    } catch (err) {
      console.log('Virhe tallennettaessa session storage tietoa avaimella ', cacheKey)
      this.errorHandler.handleError(err)
    }
  }

  getFromSessionStorage<T>(cacheKey: string): T | null {
    try {
      if (window && window.sessionStorage) {
        const cacheStr = window.sessionStorage.getItem(cacheKey)
        if (cacheStr) {
          return JSON.parse(cacheStr) as T
        }
      }
    } catch (err) {
      console.log('Virhe haettaessa session storage tietoa avaimella ', cacheKey)
      this.errorHandler.handleError(err)
    }
    return null
  }

  async getFromSessionStorageWithRetries<T>(cacheKey: string, retriesAllowed: number = 10, retrySleepMs: number = 50): Promise<T | null> {
    let retries = 0
    while (retries < retriesAllowed) {
      // Sleep
      await this.sleep(retrySleepMs)

      // Read value
      const value = this.getFromSessionStorage<T>(cacheKey)
      if (value) {
        return value
      }

      // Retry if not found
      retries++
      console.log(`getFromSessionStorageWithRetries, retry attempt number ${retries}`)
    }

    return null
  }

  protected async sleep(delay: number): Promise<void> {
    return new Promise<void>(resolve => setTimeout(resolve, delay))
  }

  // setToCache<T>(cacheKey: string, item: T, kayttajanTiedot: KayttajanTiedot) {
  //   try {
  //     if (window && window.localStorage) {
  //       const data: AsiakaskohtainenCache<T> = { cid: kayttajanTiedot.asiakasId, data: item }
  //       window.localStorage.setItem(cacheKey, JSON.stringify(data))
  //     }
  //   } catch (err) {
  //     console.log('Virhe tallennettaessa local storage tietoa avaimella ', cacheKey)
  //     this.errorHandler.handleError(err)
  //   }
  // }

  // getFromCache<T>(cacheKey: string, kayttajanTiedot: KayttajanTiedot): T | null {
  //   try {
  //     if (window && window.localStorage) {
  //       const cacheStr = window.localStorage.getItem(cacheKey)
  //       if (cacheStr) {
  //         const obj = JSON.parse(cacheStr) as AsiakaskohtainenCache<T>
  //         if (obj.cid.toString() === kayttajanTiedot.asiakasId + '') {
  //           return obj.data
  //         }
  //       }
  //     }
  //   } catch (err) {
  //     console.log('Virhe haettaessa local storage tietoa avaimella ', cacheKey)
  //     this.errorHandler.handleError(err)
  //   }
  //   return null
  // }
}
